import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import styles from "./style.module.css";
import { Flip, toast } from "react-toastify";
import Lottie from "react-lottie-player";
import PoweredByGoogleImg from "../../assets/images/powered-by-google 1.png";
import warningImage from "../../assets/images/question.svg";
import cancelImage from "../../assets/images/cancelIcn.svg";
import serverErrorImage from "../../assets/images/server_error.svg";
import ofdImage from "../../assets/images/ofd_icon.svg";
import loadingSpinner from "../../assets/animations/loading_spinner.json";
import HeadFoot from "../common/HeadFoot";
import InputLabel from "../../components/atoms/InputLabel";
import SearchLocationInput from "../common/SearchLocationInput/SearchLocationInput";
import BlitzLogo from "../../assets/images/blitz_logo.svg";
import Button from "../../components/atoms/Button";
import ModalForm from "../../components/atoms/Modal";
import SuccessMsgBox from "../common/ResponseModal";
import { useDetectSource } from "../common/useDetectsource/usedetectsource";
import { validateAndCancel, validateAndSubmitNdr } from "../../utils/api";
import { useWhitelisting } from "../../utils/hooks/useWhitelisting";
import { fetchLocation } from "../../utils/api";
import { validationPhoneField } from "../../utils/validations/phone";
import { useDispatch } from "react-redux";
import { initiateApiCall } from "../../store/actions/companyInfo";
import { searchAwb } from "../../utils/api";
import { getAWBFailure, getAWBSuccess } from "../../store/actions/awb";
import { verifyOtpActionForEdit } from "../../utils/api";
import { setCompanyInfo } from "../../store/actions/companyInfo";
import { ErrorMessageBox } from "../common/ResponseModal";
import ErrorImg from "../../assets/images/error_icon.svg";
import { validationTextField } from "../../utils/validations/textField";
import GoogleAd from "../common/GoogleAd/googleAds";
import { getAnalytics, logEvent } from "firebase/analytics";
import MapView from "./MapView";
import ReactTooltip from "react-tooltip";

// toast.configure();

const options = {
  position: toast.POSITION.BOTTOM_RIGHT,
  transition: Flip,
  toastClassName: "toast",
  closeButton: false,
};

const Address = () => {
  const dispatch = useDispatch();
  const param = useParams();

  const forbiddenStatus = [
    "RTO Out for Delivery",
    "RTO In-Transit",
    "RTO Freeze",
    "RTO Cancelled",
    "RTO Delivered",
    "Lost",
    "Delivered",
    "Cancelled",
  ];

  const handledErrors = {
    "Pincode Not Serviceable": {
      heading: "Pincode Not Serviceable",
      icon: ErrorImg,
    },
    "Shipment details not found": {
      heading: "Something Went Wrong",
      icon: serverErrorImage,
    },
    "Ineligible Request": {
      heading: "Not Allowed",
      icon: serverErrorImage,
    },
    "Shipment is out for delivery": {
      heading: "Address Update Not Allowed",
      icon: ofdImage,
    },
    "The entered address is too far from your current location. Please provide an address closer to your current location.":
      {
        heading: "Address Out Of Serviceable Area",
        icon: ErrorImg,
      },
    "Something went wrong": {
      heading: "Please Try Again",
      icon: serverErrorImage,
    },
  };

  const { isWhitelisted, trackingPageLogo: logo } = useWhitelisting();
  const { isComingFromWhatsApp, otp } = useDetectSource();
  const awb = param.awbInfo;

  const [loadingAwbData, setLoadingAwbData] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [enablePinCodeField, setEnablePinCodeField] = useState(false);
  const [ndrError, setNdrError] = useState("");
  const [pinCodeValidity, setPinCodeValidity] = useState(true);
  const [successMessageModal, setSuccessMessageModal] = useState(false);
  const [showCancelConfirmation, setShowCancelConfirmation] = useState(false);
  const [orderDetails, setOrderDetails] = useState({
    createdAt: null,
    shopOrderNumber: null,
    subOrderId: null,
  });

  // * State to track if the google address input field should be red or not, initially set to true
  const [isRedInputBorder, setIsRedInputBorder] = useState(true);
  //* State to track if address is from google places or not
  const [isAddressFromGoogle, setIsAddressFromGoogle] = useState(false);
  //* State to store the old lat lng value to compare with new lat lng value
  const [oldLatLng, setOldLatLng] = useState({
    lat: null,
    lng: null,
  });
  //* State to store the reschedule address details
  const [reschedule, setReschedule] = useState({
    name: "",
    number: "",
    pincode: "",
    city: "",
    state: "",
    date: "",
    time: "",
    address1: "",
    address2: "",
    deliveryInstruction: "",
    lat: null,
    lng: null,
  });

  const [rescheduleError, setRescheduleError] = useState({
    name: null,
    number: null,
    address: null,
    date: null,
    time: null,
  });

  const { address1, address2, number, name, pincode, lat, lng } = reschedule;
  const { createdAt, shopOrderNumber } = orderDetails;

  const formattedAddress =
    address1 !== null && address1.length !== 0
      ? `${`${address1},`} ${address2}`
      : address2;

  const isOldAddress = () =>
    oldLatLng.lat === reschedule.lat && oldLatLng.lng === reschedule.lng;

  //* Disable submit if any of the following conditions are true
  const disableSubmit =
    loadingAwbData ||
    submitLoading ||
    pincode === "" ||
    pincode === null ||
    pincode?.length !== 6 ||
    address2 === "" ||
    name === "" ||
    number === "" ||
    number.length !== 10 ||
    rescheduleError.address ||
    rescheduleError.number ||
    rescheduleError.pincode ||
    !pinCodeValidity ||
    isOldAddress() ||
    !isAddressFromGoogle;
  //****/

  const setRescheduleProp = ({ key, value }) => {
    setReschedule((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const setPinCode = (pincode) =>
    setRescheduleProp({ key: "pincode", value: pincode });

  const setPinFromGoogleCode = (pincode) => {
    if (pincode?.length === 6 && pincode !== null) {
      setEnablePinCodeField(false);
      setRescheduleProp({ key: "pincode", value: pincode });
    } else {
      setRescheduleProp({ key: "pincode", value: "" });
      setEnablePinCodeField(true);
    }
  };

  const setNewCity = (cityName) =>
    setRescheduleProp({ key: "city", value: cityName });

  const setNewState = (stateName) =>
    setRescheduleProp({ key: "state", value: stateName });

  const setFormattedAddress = (address) =>
    setRescheduleProp({ key: "address2", value: address });

  const setLocation = ({ lat, lng }) =>
    setReschedule((prevRes) => ({ ...prevRes, lat, lng }));

  const handleSubmit = async () => {
    try {
      setSubmitLoading(true);
      setNdrError("");
      const response = await validateAndSubmitNdr({
        awbNumber: awb,
        newAddress: formattedAddress,
        newContact: number,
        newName: name,
        newPin: pincode,
        otp: otp,
        lat: lat,
        lng: lng,
        createdAt: createdAt,
        shopOrderNumber: shopOrderNumber,
      });

      if (response?.data?.code === "200" && response?.data !== null) {
        setSuccessMessageModal(true);
      } else {
        const errorMessage = response?.data?.status;
        if (
          handledErrors[errorMessage] !== null &&
          handledErrors[errorMessage] !== undefined &&
          errorMessage !== undefined
        ) {
          if (errorMessage === "Shipment is out for delivery") {
            setTimeout(() => {
              window.location.href = `/${param.awbInfo}`;
            }, 2000);
          }
          setNdrError(errorMessage);
        } else {
          setNdrError("Shipment details not found");
        }
      }
      setSubmitLoading(false);
    } catch (error) {
      console.log("error: ", error);
      setSubmitLoading(false);
      setNdrError("Something went wrong");
    }
  };

  const handleCancel = async () => {
    try {
      const response = await validateAndCancel({
        awb: param.awbInfo,
        otp: otp,
        subOrderId: orderDetails.subOrderId,
      });

      if (response?.data?.code === "200") {
        setNdrError("");
        setSuccessMessageModal(true);
      } else {
        const errorMessage = response?.data?.status;
        toast.error(errorMessage ?? "Something went wrong!", options);
      }
    } catch (error) {
      console.log("error: ", error);
      toast.error("Something went wrong!", options);
    }
  };

  const getAwb = async () => {
    try {
      if (!isComingFromWhatsApp) return;
      setLoadingAwbData(true);
      let data;

      dispatch(initiateApiCall());

      if (otp) {
        data = await verifyOtpActionForEdit(otp, param.awbInfo);
      } else {
        data = await searchAwb(param.awbInfo);
      }

      if (data?.code === "200") {
        const orderDetails = data?.result?.orderDetail[0]?.order;
        const subOrderId = data?.result?.orderDetail[0]?.suborder_id;
        const shipmentDetails = data?.result?.shipmentDetails;
        const lastKnownAddress = data?.result?.lastestAddress?.shippingAddress;
        const trackingData = data?.result?.trackingDetails?.[0]?.tracking;

        for (let i = 0; i < trackingData.length; i++) {
          const data = trackingData[i];

          if (forbiddenStatus.includes(data?.shipmentStatus)) {
            window.location.href = `/${awb}`;
          }
        }

        setOrderDetails({
          subOrderId,
          createdAt: orderDetails?.created_at,
          shopOrderNumber: shipmentDetails?.shopordernumber,
        });

        setOldLatLng({
          lat: orderDetails?.shipping_latitude,
          lng: orderDetails?.shipping_longitude,
        });

        setReschedule((prevData) => ({
          ...prevData,
          name: lastKnownAddress?.name,
          number: lastKnownAddress?.msisdn,
          city: lastKnownAddress?.city,
          state: lastKnownAddress?.state,
          pincode: lastKnownAddress?.pinCode,
          lat: orderDetails?.shipping_latitude,
          lng: orderDetails?.shipping_longitude,
          address2: orderDetails?.shipping_address1,
          address1: orderDetails?.shipping_address2,
        }));

        dispatch(setCompanyInfo(data?.result?.companyInfo));
        dispatch(getAWBSuccess("data", data?.result));
      } else {
        dispatch(getAWBFailure());
      }
    } catch (error) {
      toast.error("Something went wrong!", options);
    } finally {
      setLoadingAwbData(false);
    }
  };

  useEffect(() => {
    getAwb();
  }, [isComingFromWhatsApp]);


  const handlePinCodeInput = async (value) => {
    setPinCode(value);
    if (value.length === 6) {
      const data = await fetchLocation(value);
      if (data?.length > 0) {
        setReschedule((prev) => ({
          ...prev,
          city: data[0]?.city,
          state: data[0]?.state,
        }));
        setPinCodeValidity(true);
      } else {
        setPinCodeValidity(false);
      }
    }
  };

  const onChangeValue = async (event) => {
    const id = event.target.id;
    const value = event.target.value;

    setReschedule((prevReschedule) => ({ ...prevReschedule, [id]: value }));

    //* Validations
    if (id === "address1") return;

    if (id === "number") {
      validationPhoneField(
        document.getElementById(id),
        rescheduleError,
        id,
        setRescheduleError
      );
      validationPhoneField(
        document.getElementById(id),
        rescheduleError,
        id,
        setRescheduleError
      );
    } else {
      validationTextField(
        document.getElementById(id),
        rescheduleError,
        id,
        setRescheduleError
      );
      validationTextField(
        document.getElementById(id),
        rescheduleError,
        id,
        setRescheduleError
      );
    }

    if (id === "pincode") {
      handlePinCodeInput(value);
    }
    //****/
  };

  const ndrActions = [
    {
      backgroundColor: "#fff",
      color: "#FF756C",
      borderRadius: "6px",
      border: "1px solid #FF756C",
      text: "Cancel Order",
      onClick: () => setShowCancelConfirmation(true),
    },
    {
      backgroundColor: "#0075FF",
      color: "#fff",
      borderRadius: "6px",
      border: "none",
      text: "Update address",
      onClick: () => {
        window.location.reload();
      },
    },
  ];

  const cancelActions = [
    {
      backgroundColor: "#fff",
      color: "#0075FF",
      borderRadius: "6px",
      border: "1px solid #0075FF",
      text: "Back",
      onClick: () => setShowCancelConfirmation(false),
    },
    {
      backgroundColor: "#FF756C",
      color: "#fff",
      borderRadius: "6px",
      border: "none",
      text: "Cancel Order",
      onClick: handleCancel,
    },
  ];

  const retryActions = [
    {
      backgroundColor: "#0075FF",
      color: "#fff",
      borderRadius: "6px",
      border: "none",
      text: "Retry",
      onClick: () => setNdrError(""),
    },
  ];

  const dialogHeading = showCancelConfirmation
    ? "Cancel order?"
    : handledErrors[ndrError]?.heading;

  const getActions = () => {
    if (showCancelConfirmation) {
      return cancelActions;
    }

    switch (ndrError) {
      case "Something went wrong":
      case "Shipment details not found":
        return retryActions;

      case "Pincode Not Serviceable":
      case "The entered address is too far from your current location. Please provide an address closer to your current location.":
        return ndrActions;

      default:
        return [];
    }
  };

  const getDialogText = () => {
    if (showCancelConfirmation) {
      return "Are you sure you want to cancel your order?";
    }

    switch (ndrError) {
      case "Pincode Not Serviceable":
        return "This location is not serviceable. Please select a different location for delivery.";

      default:
        return ndrError;
    }
  };

  // Function to generate tooltip text based on conditions
  const generateTooltipText = () => {
    if (isOldAddress()) {
      return "Please provide us a better address";
    }
    if (!isAddressFromGoogle) {
      return "Please select a valid address";
    }

    return "Please fill all the fields";
  };

  //* If source is not WhatsApp, return null(Blank page will be loaded)
  if (!isComingFromWhatsApp) {
    return null;
  }

  //* Source is whatsapp, render the component
  return (
    <div>
      <HeadFoot logo={isWhitelisted ? logo : BlitzLogo} />

      <div className={styles.addressContainerOuter}>
        <div className={styles.addressContainerInnerWrapper}>
          <div className={styles.addressContainerInner}>
            <div className={styles.innercontainerheading}>Customer Details</div>

            <div style={{ marginTop: "1rem" }}>
              <div className={styles.nameContainer}>
                <div style={{ flex: "1" }}>
                  <InputLabel
                    nameError={rescheduleError["name"]}
                    onChange={(event) => onChangeValue(event)}
                    inputWidth={100}
                    paddingLeft={"0.5rem"}
                    height={"4.5"}
                    disabled={loadingAwbData}
                    keyColor={"#6E6E7A"}
                    value={
                      reschedule["name"] !== null ? reschedule["name"] : ""
                    }
                    borderRadius={7}
                    placeholder={"Enter Name"}
                    placeholderSize={"12px"}
                    id={"name"}
                    className={"name"}
                    keyLabel={"Name*"}
                  />
                </div>
                <div style={{ flex: "1" }}>
                  <InputLabel
                    nameError={rescheduleError["number"]}
                    inputWidth={100}
                    paddingLeft={"0.5rem"}
                    height={"4.5"}
                    disabled={loadingAwbData}
                    keyColor={"#6E6E7A"}
                    value={
                      reschedule["number"] !== null ? reschedule["number"] : ""
                    }
                    onChange={(event) => onChangeValue(event)}
                    borderRadius={7}
                    placeholder={"Phone Number"}
                    placeholderSize={"12px"}
                    id={"number"}
                    className={"phone"}
                    keyLabel={"Phone Number*"}
                    type={"number"}
                  />
                </div>
              </div>

              <div className={styles.addressPickerContainer}>
                <img
                  src={PoweredByGoogleImg}
                  className={styles.googleImage}
                  alt="google_logo"
                />

                <SearchLocationInput
                  labelText={"Address*"}
                  address2={address2}
                  setNewCity={setNewCity}
                  setNewState={setNewState}
                  setPin={setPinFromGoogleCode}
                  setFormattedAddress={setFormattedAddress}
                  awb={param.awbInfo}
                  setLocation={setLocation}
                  setIsAddressFromGoogle={setIsAddressFromGoogle}
                  isRedInputBorder={isRedInputBorder}
                  setIsRedInputBorder={setIsRedInputBorder}
                />
              </div>
              {/* Map visible in mobile view or tablet view */}
              <div className={styles.mobileMapContainer}>
                <MapView
                  location={{
                    lat: +lat,
                    lng: +lng,
                  }}
                  setFormattedAddress={(address) =>
                    setReschedule((prevData) => ({
                      ...prevData,
                      address2: address,
                    }))
                  }
                  setPin={(pinCode) => {
                    setReschedule((prevData) => ({
                      ...prevData,
                      pincode: pinCode,
                    }));
                  }}
                  setNewCity={(cityName) => {
                    setReschedule((prevData) => ({
                      ...prevData,
                      city: cityName,
                    }));
                  }}
                  setNewState={(stateName) => {
                    setReschedule((prevData) => ({
                      ...prevData,
                      state: stateName,
                    }));
                  }}
                  setLocation={(location) => {
                    setReschedule((prevData) => ({
                      ...prevData,
                      ...location,
                    }));
                  }}
                  setIsAddressFromGoogle={setIsAddressFromGoogle}
                  setIsRedInputBorder={setIsRedInputBorder}
                />
              </div>
              <div style={{ marginTop: "1rem", position: "relative" }}>
                <InputLabel
                  nameError={rescheduleError["address1"]}
                  inputWidth={100}
                  paddingLeft={"0.5rem"}
                  height={"4.5"}
                  keyColor={"#6E6E7A"}
                  value={
                    reschedule["address1"] !== null
                      ? reschedule["address1"]
                      : ""
                  }
                  onChange={(event) => onChangeValue(event)}
                  borderRadius={7}
                  placeholder={"Flat / House No / Building"}
                  placeholderSize={"12px"}
                  id={"address1"}
                  border={"1px solid black"}
                  className={"address1"}
                  keyLabel={"Flat / House No / Building"}
                  disabled={loadingAwbData}
                />
              </div>

              <div className={styles.pincodeContainer}>
                <div className={styles.companyLink} style={{ flex: "1" }}>
                  <InputLabel
                    onChange={(event) => onChangeValue(event)}
                    inputWidth={100}
                    paddingLeft={"0.5rem"}
                    height={"4.5"}
                    disabled={!enablePinCodeField}
                    keyColor={"#6E6E7A"}
                    value={pincode}
                    borderRadius={7}
                    placeholder={"Pincode"}
                    placeholderSize={"12px"}
                    id={"pincode"}
                    className={"pincode"}
                    keyLabel={"Pincode*"}
                    type={"number"}
                    pincodeType={true}
                  />
                  <div
                    style={{
                      fontSize: "12px",
                      color: "red",
                      marginTop: "0.2rem",
                    }}
                  >
                    {!pinCodeValidity && pincode?.length === 6
                      ? "Pincode out of serviceable area"
                      : ""}
                  </div>
                </div>
                <div style={{ flex: "1" }}>
                  <InputLabel
                    onChange={(event) => onChangeValue(event)}
                    paddingLeft={"0.5rem"}
                    height={"4.5"}
                    disabled={true}
                    keyColor={"#6E6E7A"}
                    value={
                      reschedule["city"] !== null ? reschedule["city"] : ""
                    }
                    borderRadius={7}
                    placeholder={"City"}
                    placeholderSize={"12px"}
                    id={"city"}
                    className={"city"}
                    keyLabel={"City"}
                  />
                </div>
                <div style={{ flex: "1" }}>
                  <InputLabel
                    onChange={(event) => onChangeValue(event)}
                    paddingLeft={"0.5rem"}
                    disabled={true}
                    height={"4.5"}
                    value={
                      reschedule["state"] !== null ? reschedule["state"] : ""
                    }
                    keyColor={"#6E6E7A"}
                    borderRadius={7}
                    placeholder={"State"}
                    placeholderSize={"12px"}
                    id={"state"}
                    className={"state"}
                    keyLabel={"State"}
                  />
                </div>
              </div>
              <div className={styles.ctaContainer}>
                <Button
                  minHeight={35}
                  text={submitLoading ? "..." : "Submit"}
                  width={"17vh"}
                  height={"36px"}
                  opacity={disableSubmit ? 0.6 : 1}
                  disabled={disableSubmit ? true : false}
                  backgroundColor={"#0075FF"}
                  border={"none"}
                  color={"#fff"}
                  onclick={handleSubmit}
                  data-tip
                  data-for="submit-btn"
                />
                {disableSubmit && (
                  <ReactTooltip
                    placement="top"
                    type="dark"
                    id="submit-btn"
                    effect="solid"
                  >
                    {generateTooltipText()}
                  </ReactTooltip>
                )}
              </div>
            </div>
          </div>
          {/* Map Visible in desktop view */}
          <div className={styles.desktopMapContainer}>
            <MapView
              location={{
                lat: +lat,
                lng: +lng,
              }}
              setFormattedAddress={(address) =>
                setReschedule((prevData) => ({
                  ...prevData,
                  address2: address,
                }))
              }
              setPin={(pinCode) => {
                setReschedule((prevData) => ({
                  ...prevData,
                  pincode: pinCode,
                }));
              }}
              setNewCity={(cityName) => {
                setReschedule((prevData) => ({
                  ...prevData,
                  city: cityName,
                }));
              }}
              setNewState={(stateName) => {
                setReschedule((prevData) => ({
                  ...prevData,
                  state: stateName,
                }));
              }}
              setLocation={(location) => {
                setReschedule((prevData) => ({
                  ...prevData,
                  ...location,
                }));
              }}
              setIsAddressFromGoogle={setIsAddressFromGoogle}
              setIsRedInputBorder={setIsRedInputBorder}
            />
          </div>
        </div>
        {/* <div style={{ width: "100%", textAlign: "center" }}>
          <GoogleAd slot={"5267234543"} />
        </div> */}

        {submitLoading || loadingAwbData ? (
          <div>
            <ModalForm
              isOpen
              width={350}
              dimensionsUnit={"px"}
              background={"#0A2A6B"}
              noNavbar={true}
              padding={0}
              withCloseIcon={false}
              close={() => setSuccessMessageModal(false)}
              onClose={() => setSuccessMessageModal(false)}
              className={styles.loadingModal}
              renderContent={() => (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                >
                  <Lottie
                    loop
                    animationData={loadingSpinner}
                    play
                    color="#fff"
                    style={{ width: 90, height: 90, color: "#fff" }}
                  />
                  <p style={{ color: "#fff" }}>
                    {loadingAwbData
                      ? "Fetching your details..."
                      : "Checking address.."}
                    .
                  </p>
                </div>
              )}
            ></ModalForm>
          </div>
        ) : null}
        {successMessageModal ? (
          <div>
            <ModalForm
              isOpen
              width={window.screen.availWidth < 600 ? "100%" : 350}
              dimensionsUnit={"px"}
              background={"#0A2A6B"}
              noNavbar={true}
              padding={0}
              withCloseIcon={false}
              close={() => setSuccessMessageModal(false)}
              onClose={() => setSuccessMessageModal(false)}
              renderContent={() => (
                <SuccessMsgBox
                  redirectOnTimer={true}
                  icon={showCancelConfirmation ? cancelImage : null}
                  title1={
                    showCancelConfirmation
                      ? "Order Cancelled"
                      : "Order Details Updated"
                  }
                  close={() => setSuccessMessageModal(false)}
                />
              )}
            ></ModalForm>
          </div>
        ) : null}

        {ndrError?.length > 0 && ndrError !== null ? (
          <div>
            <ModalForm
              isOpen
              width={window.screen.availWidth < 600 ? "100%" : 350}
              dimensionsUnit={"px"}
              background={"#0A2A6B"}
              noNavbar={true}
              padding={0}
              withCloseIcon={false}
              close={() => setNdrError("")}
              onClose={() => setNdrError("")}
              renderContent={() => (
                <ErrorMessageBox
                  heading={dialogHeading}
                  message={getDialogText()}
                  close={() => setNdrError("")}
                  errorIcon={
                    showCancelConfirmation
                      ? warningImage
                      : handledErrors[ndrError]?.icon
                  }
                  actions={getActions()}
                />
              )}
            ></ModalForm>
          </div>
        ) : null}
      </div>
    </div>
  );
};
export default Address;
